import { render } from "./LabelSceneDiagram.vue?vue&type=template&id=2e9a882e&scoped=true&ts=true"
import script from "./LabelSceneDiagram.vue?vue&type=script&lang=ts"
export * from "./LabelSceneDiagram.vue?vue&type=script&lang=ts"

import "./LabelSceneDiagram.vue?vue&type=style&index=0&id=2e9a882e&scoped=true&lang=css"
import "./LabelSceneDiagram.vue?vue&type=style&index=1&id=2e9a882e&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9a882e"]])

export default __exports__